import { Hammer } from 'lucide-react';
import type { FeatureKey } from '../types';
import styles from './PlaceholderView.module.css';

const labels: Partial<Record<FeatureKey, string>> = {
  quiz: 'Quiz',
  summary: 'Resumen',
  podcasts: 'Podcast',
  diagram: 'Diagrama',
  bibliography: 'Bibliografía',
  regulation: 'Normativa',
  glossary: 'Glosario',
  goals: 'Objetivos',
  applications: 'Aplicaciones prácticas',
  expand: 'Expandir',
  explain: 'Explicar',
  remember: 'Recordar',
  discover: 'Descubrir el curso',
  underline: 'Subrayar'
};

export function PlaceholderView({ feature }: { feature: FeatureKey }) {
  return (
    <div className={styles.empty}>
      <div className={styles.icon}>
        <Hammer size={28} strokeWidth={2} />
      </div>
      <h3 className={styles.heading}>{labels[feature] ?? feature}</h3>
      <p className={styles.body}>
        Pendiente de implementación en el rediseño. La feature equivalente del widget
        legacy ya existe y se portará a este shell respetando el design system.
      </p>
    </div>
  );
}
